var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useMemo, useState, useEffect } from "react";
import { Pane, PaneFooter, Button, Row, Col, ErrorModal, Accordion, AccordionSet, } from "@folio/stripes/components";
import { useForm, Controller } from "react-hook-form";
import { useIntl } from "react-intl";
import debounce from "lodash/debounce";
import { useHistory, useLocation } from "react-router";
import { useStableOkapiKy } from "../../hooks/useStableOkapiKy";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { RecekTextField, RecekSelection } from "../../components/inputs";
import { toErrorWithResponse } from "../../utils/httpErrors";
import { fetchOnixCodetables, fetchOnixCodetableSummary, } from "../../api/onixService";
import { FormFooterStart } from "../../components/FormFooterStart";
import { FormFooterEnd } from "../../components/FormFooterEnd";
import { navigation } from "../../components/navigation";
import { useScrollToError } from "../../hooks/useScrollToError";
var OnixCodetableItemsForm = function (_a) {
    var _b;
    var initialValues = _a.initialValues, title = _a.title, onSubmit = _a.onSubmit, returnPath = _a.returnPath, _c = _a.isEdit, isEdit = _c === void 0 ? false : _c;
    var ky = useStableOkapiKy();
    var history = useHistory();
    var location = useLocation();
    var formatMessage = useIntl().formatMessage;
    var _d = useForm({
        defaultValues: __assign({ value: "", description: "", notes: "", sortOrder: undefined, version: undefined, codetableId: undefined }, initialValues),
        mode: "onBlur",
    }), handleSubmit = _d.handleSubmit, control = _d.control, errors = _d.formState.errors, setValue = _d.setValue;
    var _e = useState(false), errorModalOpen = _e[0], setErrorModalOpen = _e[1];
    var _f = useState(""), errorMessage = _f[0], setErrorMessage = _f[1];
    useScrollToError(errors);
    var _g = useState({
        codetableId: true,
        value: true,
        description: true,
        notes: true,
        sortOrder: true,
    }), accordionStatus = _g[0], setAccordionStatus = _g[1];
    var _h = useState(true), expandAll = _h[0], setExpandAll = _h[1];
    var _j = useState((initialValues === null || initialValues === void 0 ? void 0 : initialValues.codetableId) && ((_b = initialValues === null || initialValues === void 0 ? void 0 : initialValues.onixCodetable) === null || _b === void 0 ? void 0 : _b.name)
        ? [
            {
                value: initialValues.codetableId,
                label: initialValues.onixCodetable.name,
            },
        ]
        : []), options = _j[0], setOptions = _j[1];
    var _k = useState(false), loading = _k[0], setLoading = _k[1];
    useEffect(function () {
        if (isEdit || initialValues.codetableId)
            return;
        var params = new URLSearchParams(location.search);
        var tableIdFromUrl = params.get("onixCodetableId");
        if (!tableIdFromUrl)
            return;
        var loadCodetable = function () { return __awaiter(void 0, void 0, void 0, function () {
            var table, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setLoading(true);
                        return [4 /*yield*/, fetchOnixCodetableSummary(ky, tableIdFromUrl)];
                    case 1:
                        table = _a.sent();
                        if (table && table.id && table.name) {
                            setValue("codetableId", table.id);
                            setOptions([{ value: table.id, label: table.name }]);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Failed to load onix codetable from URL:", error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        loadCodetable();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search, isEdit]);
    var doFilter = useMemo(function () {
        return debounce(function (q) { return __awaiter(void 0, void 0, void 0, function () {
            var name, res, items, e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        name = q === null || q === void 0 ? void 0 : q.trim();
                        if (!name) {
                            setOptions([]);
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        setLoading(true);
                        return [4 /*yield*/, fetchOnixCodetables(ky, { name: name })];
                    case 2:
                        res = _b.sent();
                        items = (_a = res.items) !== null && _a !== void 0 ? _a : [];
                        setOptions(items.map(function (t) { return ({ value: t.id, label: t.name }); }));
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _b.sent();
                        setOptions([]);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); }, 300);
    }, [ky]);
    var handleError = function (caught) { return __awaiter(void 0, void 0, void 0, function () {
        var error, status, body, resp, _a, _b, _c, _d, errs, isDuplicate;
        var _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    error = toErrorWithResponse(caught);
                    status = (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.status) !== null && _f !== void 0 ? _f : error === null || error === void 0 ? void 0 : error.status;
                    if (!(error === null || error === void 0 ? void 0 : error.response)) return [3 /*break*/, 8];
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 8]);
                    resp = error.response.clone
                        ? error.response.clone()
                        : error.response;
                    return [4 /*yield*/, resp.json()];
                case 2:
                    body = _g.sent();
                    return [3 /*break*/, 8];
                case 3:
                    _a = _g.sent();
                    _g.label = 4;
                case 4:
                    _g.trys.push([4, 6, , 7]);
                    _c = (_b = JSON).parse;
                    return [4 /*yield*/, error.response.text()];
                case 5:
                    body = _c.apply(_b, [_g.sent()]);
                    return [3 /*break*/, 7];
                case 6:
                    _d = _g.sent();
                    body = undefined;
                    return [3 /*break*/, 7];
                case 7: return [3 /*break*/, 8];
                case 8:
                    if (status === 422) {
                        errs = Array.isArray(body === null || body === void 0 ? void 0 : body.errors) ? body.errors : [];
                        isDuplicate = errs.some(function (e) {
                            return String(e === null || e === void 0 ? void 0 : e.type) === "-1" ||
                                (e === null || e === void 0 ? void 0 : e.code) === "VALIDATION_ERROR" ||
                                /already exists/i.test((e === null || e === void 0 ? void 0 : e.message) || "");
                        });
                        if (isDuplicate) {
                            setErrorMessage(formatMessage({
                                id: "ui-br-agency.onix-codetable-items.error.message.duplicate",
                            }));
                            setErrorModalOpen(true);
                            return [2 /*return*/];
                        }
                    }
                    setErrorMessage(formatMessage({ id: "ui-br-agency.onix-codetable-items.error.submit" }));
                    setErrorModalOpen(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var submit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!data.codetableId || !data.value) {
                        setErrorMessage(formatMessage({
                            id: "ui-br-agency.onix-codetable-items.error.required",
                        }));
                        setErrorModalOpen(true);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, onSubmit(data)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    handleError(e_2);
                    setErrorModalOpen(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            codetableId: !expandAll,
            value: !expandAll,
            description: !expandAll,
            notes: !expandAll,
            sortOrder: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(FormFooterStart, { handleSubmit: handleSubmit, onSubmit: submit, buttonMessageId: "ui-br-agency.button.save" }), renderEnd: React.createElement(FormFooterEnd, { onCancel: function () {
                        var _a;
                        return (returnPath || ((_a = navigation.onixCodetableItems) === null || _a === void 0 ? void 0 : _a.path)) &&
                            history.push(returnPath || navigation.onixCodetableItems.path);
                    }, buttonMessageId: "ui-br-agency.button.cancel" }) }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({
                    id: "ui-br-agency.modal.label.error",
                }), content: errorMessage, onClose: function () { return setErrorModalOpen(false); } }),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                    React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll
                        ? formatMessage({ id: "ui-br-agency.button.collapse" })
                        : formatMessage({ id: "ui-br-agency.button.expand" })))),
            React.createElement("form", { noValidate: true, onSubmit: handleSubmit(submit) },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { id: "codetableId", label: formatMessage({
                            id: "ui-br-agency.onix-codetable-items.form.section.codetableId",
                        }), open: accordionStatus.codetableId, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { codetableId: !accordionStatus.codetableId }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "codetableId", control: control, render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelection, { labelId: "ui-br-agency.onix-codetable-items.form.codetable.label", value: (_b = field.value) !== null && _b !== void 0 ? _b : "", asyncFilter: true, loading: loading, onFilter: doFilter, onChange: function (val) {
                                                return field.onChange(val || undefined);
                                            }, dataOptions: options, required: true, disabled: isEdit }));
                                    } })))),
                    React.createElement(Accordion, { id: "value", label: formatMessage({
                            id: "ui-br-agency.onix-codetable-items.form.section.value",
                        }), open: accordionStatus.value, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { value: !accordionStatus.value }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "value", control: control, rules: { required: true }, render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { required: true, labelId: "ui-br-agency.onix-codetable-items.form.value.label", error: ((_b = errors.value) === null || _b === void 0 ? void 0 : _b.message) ||
                                                (errors.value
                                                    ? formatMessage({
                                                        id: "stripes-core.label.missingRequiredField",
                                                    })
                                                    : undefined) })));
                                    } })))),
                    React.createElement(Accordion, { id: "description", label: formatMessage({
                            id: "ui-br-agency.onix-codetable-items.form.section.description",
                        }), open: accordionStatus.description, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { description: !accordionStatus.description }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "description", control: control, render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.onix-codetable-items.form.description.label" })));
                                    } })))),
                    React.createElement(Accordion, { id: "notes", label: formatMessage({
                            id: "ui-br-agency.onix-codetable-items.form.section.notes",
                        }), open: accordionStatus.notes, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { notes: !accordionStatus.notes }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "notes", control: control, render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.onix-codetable-items.form.notes.label" })));
                                    } })))),
                    React.createElement(Accordion, { id: "sortOrder", label: formatMessage({
                            id: "ui-br-agency.onix-codetable-items.form.section.sortOrder",
                        }), open: accordionStatus.sortOrder, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { sortOrder: !accordionStatus.sortOrder }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { name: "sortOrder", control: control, render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, { name: field.name, ref: field.ref, type: "number", value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                                                var raw = e.target.value;
                                                field.onChange(raw === "" ? undefined : Number(raw));
                                            }, onBlur: field.onBlur, labelId: "ui-br-agency.onix-codetable-items.form.sortOrder.label" }));
                                    } })))))))));
};
export default OnixCodetableItemsForm;
